import api from '@/api';
import store from '@/store';

export default {
    namespaced: true,
    state: {
        list: [],
        error: null,
        errors: null,
        requestPending: false,
    },
    mutations: {
        setList(state, list) {
            state.list = list;
        },
        clearError(state) {
            state.error = null;
        },
        setError(state, error) {
            state.error = error;
        },
        clearErrors(state) {
            state.errors = null;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        startRequest(state) {
            state.requestPending = true;
        },
        endRequest(state) {
            state.requestPending = false;
        },
    },
    actions: {
        async list(context) {
            context.commit('startRequest');
            context.commit('clearError');
            context.commit('clearErrors');

            try {
                const response = await api.statistics.list();
                context.commit('setList', response.data);
            } catch (err) {
                if (typeof err.response !== 'undefined' && typeof err.response.status !== 'undefined' && err.response.status === 401) {
                    store.dispatch('auth/login');
                    return null;
                }
                context.commit('setError', 'server');
            } finally {
                context.commit('endRequest');
            }

            return null;
        },
    },
};
